import {
  AttachmentFileMIMEType,
  AttachmentFileMIMETypeLabel,
} from '../../../../enums/Attachments';

export const ATTACHMENT_MIME_TYPES_TO_LABELS = {
  [AttachmentFileMIMEType.PDF]: AttachmentFileMIMETypeLabel.PDF_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.ZIP]: AttachmentFileMIMETypeLabel.ZIP_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.DOC]:
    AttachmentFileMIMETypeLabel.MS_DOC_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.MS_DOC]:
    AttachmentFileMIMETypeLabel.MS_DOC_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.MS_WORD]:
    AttachmentFileMIMETypeLabel.MS_DOC_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.DOCX]:
    AttachmentFileMIMETypeLabel.MS_DOC_MIME_TYPE_LABEL,
  [AttachmentFileMIMEType.PPTX]:
    AttachmentFileMIMETypeLabel.PPTX_MIME_TYPE_LABEL,
};

export const ANALYTICS_ORIGIN = {
  TASK_SETTING: 'Task Setting',
  COURSE_PAGE: 'Course Page',
  TOPIC_PAGE: 'Topic Page',
  QUESTIONS_CARD: 'Questions Card',
  TASK_INSIGHTS_PAGE: 'Task Insights Page',
  TASK_QUESTION_INSIGHTS_PAGE: 'Task Question Insights Page',
};
